// src/colors.js

export const colors = {
    green: '#4caf50',
    lightGreen: '#81c784',
  };
  